<template>
  <el-container :style="{ width: element.options.width }">
    <el-header class="sw-el-header" style="height: 50px">
      {{ element.name }}
      <div class="son-form-header-bt">
        <el-button type="primary" icon="el-icon-plus" circle>添加</el-button>
      </div>
    </el-header>
    <el-main>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column
          v-for="item in element.options.showField"
          :key="item"
          :min-width="element.options.minWidth"
        >
          <template slot="header">
            {{ fields[item] }}
          </template>
          <template></template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import formUtils from '../../../util/formUtils'
export default {
  name: 'sw-page',
  props: ['element', 'select', 'index', 'data', 'dataConfig'],
  data() {
    return {
      selectWidget: this.select,
      tableData: [],
      fields: {}, // 字段信息
    }
  },
  created() {
    if (
      this.element.options.selectPage &&
      this.data.sonPages &&
      this.data.sonPages[this.element.options.selectPage]
    ) {
      this.fields = formUtils.fieldToName(
        this.data.sonPages[this.element.options.selectPage].list,
        this.element.options.showField
      )
    }
  },
  methods: {},
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val) {
        this.$emit('update:select', val)
      },
      deep: true,
    },
    'element.options.showField': {
      handler(val) {
        this.fields = formUtils.fieldToName(
          this.data.sonPages[this.element.options.selectPage].list,
          val
        )
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.sw-el-header {
  background-color: #b5b5b52e;
  font-weight: bold;
  line-height: 40px;
}
.son-form-header-bt {
  margin-top: 4px;
  float: right;
}
</style>
